const myUtil = {
    test() {
        console.log('test')
    },
    parseTime(time, cFormat) {
        if (arguments.length === 0) {
            return null
        }
        const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if (typeof time === 'object') {
            date = time
        } else {
            if (('' + time).length === 10) time = parseInt(time) * 1000
            date = new Date(time)
        }
        const formatObj = {
            y: date.getFullYear(),
            m: date.getMonth() + 1,
            d: date.getDate(),
            h: date.getHours(),
            i: date.getMinutes(),
            s: date.getSeconds(),
            a: date.getDay()
        }
        const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
            let value = formatObj[key]
            if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
            if (result.length > 0 && value < 10) {
                value = '0' + value
            }
            return value || 0
        })
        return time_str
    },
    formatTime(time) {
        // console.log(time)
        var date = new Date(time)

        var seperator1 = '-'
        var seperator2 = ':'
        var month = date.getMonth() + 1
        var strDate = date.getDate()
        if (month >= 1 && month <= 9) {
            month = '0' + month
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = '0' + strDate
        }
        var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
            ' ' + date.getHours() + seperator2 + date.getMinutes() +
            seperator2 + date.getSeconds()
        return currentdate
    },
    startDateDef(otherDay) {
        let now = new Date()
        if (!otherDay) {
            otherDay = 6
        }
        now = new Date(now.getTime() - (3600 * 24 * 1000 * otherDay))
        let strNow = this.parseTime(now, '{y}-{m}-{d} 00:00:00')
        return new Date(strNow)
    },
    endDateDef() {
        var strNow = this.parseTime(new Date(), '{y}-{m}-{d} 00:00:00')
        let endTime = new Date(strNow).getTime() + (3600 * 24 * 1000)
        return new Date(endTime)
    },
    startDateStr(otherDay) {
        let now = new Date();
        if (!otherDay) {
            otherDay = 6
        }
        now = new Date(now.getTime() - (3600 * 24 * 1000 * otherDay));
        return this.parseTime(now, '{y}-{m}-{d} 00:00:00');
    },
    endDateStr() {
        let strNow = this.parseTime(new Date(), '{y}-{m}-{d} 00:00:00');
        let endTime = new Date(new Date(strNow).getTime() + (3600 * 24 * 1000));
        return this.parseTime(endTime, '{y}-{m}-{d} 00:00:00');
    },
    getWindowSize() {
        let windowSize = {}
        windowSize.width = window.innerWeight || document.documentElement.clientWidth || document.body.clientWidth
        windowSize.height = window.innerWeight || document.documentElement.clientHeight || document.body.clientHeight
        return windowSize
    },
    getLayoutStyle() {
        return {'min-height': this.getWindowSize().height + 'px', 'background': '#f8f8f8'}
    },
    formatCardAcctName(str) {
        return str ? str.substr(0, 1) + '*' : ''
    },
    formatCardNo(str) {
        return str ? str.replace(/\s/g, '').replace(/[^\d]/g, '').replace(/(\d{4})(?=\d)/g, '$1 ') : ''
    },
    fourSeparateFormat(str) {
        return str ? str.replace(/\s/g, '').replace(/(....)(?=.)/g, '$1 ') : ''
    },
    removefourSeparateFormat(str) {
        return str ? str.replace(/\s/g, '') : ''
    },
    separateFormatMoible(str) {
        return str ? str.replace(/\s/g, '').replace(/(^\d{3}|\d{4}\B)/g, '$1 ') : ''
    },
    //= ===========20180912
    idCard(val) {
        return /^[1-9]{1}[0-9]{14}$|^[1-9]{1}[0-9]{16}([0-9]|[xX])$/.test(val)
    },
    mobile(val) {
        return /^1[0-9]{10}$/.test(val)
    },
    isZSHGasCardNo(val) {
        return /^[0-9]{19}$/.test(val)
    },
    isZSYGasCardNo(val) {
        return /^[0-9]{16}$/.test(val)
    },
    address(val) {
        const value = val.trim()
        return value.length >= 5 && value.length <= 100
    },
    userName(val) {
        return /^[a-zA-Z0-9_\u4e00-\u9fa5]{3,20}$/.test(val)
    },
    isLegalPwd(val) {
        return /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[^\x00-\xff].*$)^\S{6,25}$/.test(val)
    },
    isCertNo(str) {
        return /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(str)
    },
    //= ===========
    /* 合法uri */
    validateURL(textval) {
        const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
        return urlregex.test(textval)
    },
    /* 小写字母 */
    validateLowerCase(str) {
        const reg = /^[a-z]+$/
        return reg.test(str)
    },
    /* 大写字母 */
    validateUpperCase(str) {
        const reg = /^[A-Z]+$/
        return reg.test(str)
    },
    /* 大小写字母 */
    validatAlphabets(str) {
        const reg = /^[A-Za-z]+$/
        return reg.test(str)
    },
    objToparam(obj) {
        let param = ''
        for (let key in obj) {
            param += key + '=' + obj[key] + '&'
        }
        return param.Length > 0 ? param.substring(0, param.length - 1) : param
    },
    navigatorUserAgent() {
        if (/MicroMessenger/.test(window.navigator.userAgent)) {
            return 'WeChat'
        } else if (/AlipayClient/.test(window.navigator.userAgent)) {
            return 'Allipay'
        } else {
            return 'Other'
        }
    },
    isUserAgentWeChat() {
        return /MicroMessenger/.test(window.navigator.userAgent)
    },
    isUserAgentAllipay() {
        return /AlipayClient/.test(window.navigator.userAgent)
    },
    isUserAgentOther() {
        return navigatorUserAgent() === 'Other'
    },
    // 压缩图片
    compressImg(img, size) {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        // let initSize = img.src.length;
        let width = img.width;
        let height = img.height;
        canvas.width = width;
        canvas.height = height;
        // 铺底色
        // ctx.fillStyle = '#fff';
        // ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, width, height);
        //进行最小压缩
        return canvas.toDataURL('image/jpeg', size);
    },
    // base64转Blob
    base64ImgDataToBlob(base64ImgData) {
        let arr = base64ImgData.split(',');
        let byteString = atob(arr[1]);
        let u8arr = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            u8arr[i] = byteString.charCodeAt(i);
        }
        let mimeString = arr[0].match(/:(.*?);/)[1];
        return new Blob([u8arr], {type: mimeString});
    },
    // base64转文件
    base64ImgDataToFile(base64ImgData, name) {
        let blob = this.base64ImgDataToBlob(base64ImgData);
        return new File([blob], name + ".jpg", {type: "image/jpeg"});
    },
}
export {myUtil}

export default {
    install(Vue) {
        Object.defineProperties(Vue.prototype, {
            $myUtil: {
                value: myUtil
            }
        })
    }
}
